import React from 'react'
import { I18n, CDNImage } from '@front/volcanion/'

import { Grid, Box, StepLabel, StepContent, IconButton } from '@mui/material'
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

import { DateField, TextField, MenuSelectorField, SingleOptionSelectorField, Loader, ConfirmationDialog, NumberField } from '@front/squirtle'
import { SuspensionTitleForm } from '@abra/elements/Suspensions'



const Rows = ({ isManagingRecord, statusColor, statusChange, verifyClientId }) =>
  <Grid container spacing={2} rowSpacing={5}>
    <Grid size={3}>
      <TextField name='info.user_client_id' label={I18n.t('driver.code')} debounceTime={250} required={!!isManagingRecord} afterUserChange={verifyClientId} />
    </Grid>
    <Grid size={3}>
      <TextField name='info.last_name' label={I18n.t('name.label', { count: 1 })} required />
    </Grid>
    <Grid size={3}>
      <TextField name='info.first_name' label={I18n.t('name.first_name', { count: 1 })} required />
    </Grid>
    <Grid size="grow">
      <MenuSelectorField
        label={I18n.t('gender.label')}
        name='info.gender'
        options={_.compact([
          { label: I18n.t('gender.female'), value: 'F' },
          { label: I18n.t('gender.male'), value: 'M' },
        ])}
        noneLabel={I18n.t('gender.unknow')}
      />
    </Grid>
    <Grid hidden={!isManagingRecord} size={3}>
      <TextField name='score.average_rating' label={I18n.t('evaluation.note', { count: 1 })} disabled />
    </Grid>
    <Grid hidden={!isManagingRecord} size={3}>
      {!!isManagingRecord && <DateField
        name={'info.createdAt'}
        label={I18n.t('date.create')}
        inputFormat={'DD/MM/YYYY'}
        disabled
        disableOpenPicker
      />}
    </Grid>
    <Grid hidden={!isManagingRecord} size={3}>
      {!!isManagingRecord && <DateField
        name={'info.updatedAt'}
        label={I18n.t('date.updatedAt')}
        inputFormat={'DD/MM/YYYY HH:mm'}
        mask={'__/__/____ __:__'}
        disabled
        disableOpenPicker
      />}
    </Grid>
    <Grid size={2}>
      <MenuSelectorField
        label={I18n.t('status.label', { count: 1 })}
        name={'status'}
        options={_.compact([
          { label: I18n.t('status.active'), value: 'active' },
          { label: I18n.t('status.deleted'), value: 'deleted', disabled: !isManagingRecord },
          { label: I18n.t('status.suspended'), value: 'suspended', disabled: !isManagingRecord }
        ])}
        valueDecoratorProps={{
          sx: { WebkitTextFillColor: statusColor, fontWeight: 600 }
        }}
        selectFirst
        required
        afterChange={statusChange}
      />
    </Grid>
    <Grid size={2}>
      <NumberField name='score.base_points' label={I18n.t('score.base_points')} />
    </Grid>
    <Grid size={2}>
      <NumberField name='score.temporary_points' label={I18n.t('score.temporary_points')} />
    </Grid>
    <Grid size={3}>
      <NumberField name='score.temporary_points_count' label={I18n.t('score.temporary_points_count')} alwaysInclude />
    </Grid>
    <Grid size={2}>
      <NumberField name='score.system_points' label={I18n.t('score.system_points')} disabled />
    </Grid>
    <Grid size={3}>
      <NumberField name='score.system_points_count' label={I18n.t('score.system_points_count')} disabled />
    </Grid>
    <Grid size={2}>
      <SingleOptionSelectorField
        name={'driverinfo.can_call_booker'}
        label={I18n.t('call.all_client')}
        clearOnEmpty={false}
      />
    </Grid>
  </Grid>


const Side1 = (props) => {
  const {
    photoURL,
    hasPhoto,
    driverCDN,
    onDeletePhoto,
    onConfirmDeletePhoto,
    hasPhotoState,
    onUploadPhoto,
    canModifyImage
  } = props || {}

  return (
    <Box>
      <ConfirmationDialog
        name={'confirm_delete_photo'}
        onConfirm={onDeletePhoto}
      />
      <Loader isLoading={hasPhotoState?.isLoading || (!!hasPhoto && !photoURL)} size={30} >
        {!!hasPhoto ?
          <IconButton onClick={onConfirmDeletePhoto}>
            <img src={photoURL} width={150} height={150} style={{ borderRadius: '50%', maxWidth: '100%' }} />
            {canModifyImage && <ClearOutlinedIcon style={{ position: 'absolute', top: 10, right: 10, backgroundColor: 'grey' }} />}
          </IconButton>
          : <IconButton component="label">
            {canModifyImage && (
              <input
                type="file"
                accept=".jpg, .jpeg"
                id="faceImage"
                hidden
                onChange={onUploadPhoto}
              />
            )}
            <CDNImage name={driverCDN} category='images' style={{ maxHeight: 150, maxWidth: 150 }} />
            {canModifyImage && <EditOutlinedIcon style={{ position: 'absolute', top: 10, right: 10 }} />}
          </IconButton>
        }
      </Loader >
    </Box>
  )
}


const PrimarySection = props => {
  const {
    user_auth_id,
    isManagingRecord,
    statusColor,
    statusChange,
    verifyClientId,
    isReadOnly
  } = props || {}


  return (
    <>
      <StepLabel>
        <SuspensionTitleForm
          label={I18n.t('info.general')}
          record_id={user_auth_id}
        />
      </StepLabel>
      <StepContent>
        <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
          <Grid container spacing={2} rowSpacing={5}>
            <Grid size={9} >
              <Rows isManagingRecord={isManagingRecord} statusColor={statusColor} statusChange={statusChange} verifyClientId={verifyClientId} />
            </Grid>
            <Grid hidden={!isReadOnly} size={3}>
              <Side1 {...props} />
            </Grid>
          </Grid>
        </Box>
      </StepContent >
    </>
  );
}
export default React.memo(PrimarySection)
